import { isBefore } from 'date-fns';
import { useEffect, useState } from 'react';

import { useAuth } from '../providers';
import { DrawController, DrawOptions } from '../types/Draw';
import { parseDate } from '../utils/datetime';

const firstSupportedDrawLaunch = new Date(2022, 10, 24, 0, 0, 0, 0);

export function useDraw(options: DrawOptions): DrawController {
  const { user } = useAuth();

  const [draw, setDraw] = useState(options.draw);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const { drawGateway, product, purchasingController } = options;
    const purchasingProduct = purchasingController?.product;

    if (
      !purchasingController ||
      !purchasingProduct ||
      !drawGateway ||
      !product ||
      !['draw-release', 'auction'].includes(product.releaseType)
    ) {
      return;
    }

    const parsedLaunchDate = parseDate(product.launchDate);

    if (!parsedLaunchDate) return;

    // Older draw's were not supported by the draws service. This prevents loads of not
    // found errors being recorded by Grafana and Sentry.
    if (isBefore(parsedLaunchDate, firstSupportedDrawLaunch)) return;

    const { shopifyId } = purchasingProduct;

    setLoading(true);
    drawGateway.getDrawByProductId(shopifyId).then((r) => {
      if (!r) return;

      setDraw(r);
      setLoading(false);
    });
  }, [user, options.purchasingController?.product, setDraw]);

  return { draw, loading };
}
